import { render } from "./RoleDialog.vue?vue&type=template&id=5ecde490&scoped=true&ts=true"
import script from "./RoleDialog.vue?vue&type=script&lang=ts"
export * from "./RoleDialog.vue?vue&type=script&lang=ts"

import "./RoleDialog.vue?vue&type=style&index=0&id=5ecde490&scoped=true&lang=scss"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ecde490"]])

export default __exports__